import styled from 'styled-components'
import { Text, TextLevel } from '@lmc/ui-kit/src/general'

export type InitialsAvatarProps = {
  name: string
  size?: number
  level?: TextLevel
}

const InitialsAvatar = ({
  name,
  size = 36,
  level = 2,
}: InitialsAvatarProps) => {
  const nameParts = name.split(' ')
  const initials = nameParts
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  return (
    <Avatar size={size}>
      <Text level={level}>{initials}</Text>
    </Avatar>
  )
}

const Avatar = styled.div<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.color.neutral.color8};
  color: ${(props) => props.theme.color.neutral.color3};
  border: 1px solid ${(props) => props.theme.color.neutral.color5};
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;

  &:hover {
    cursor: default;
  }
`

export default InitialsAvatar
